var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81555556,8.05888889 C5.93555556,10.26 7.74,12.0566667 9.94111111,13.1844444 L11.6522222,11.4733333 C11.8622222,11.2633333 12.1733333,11.1933333 12.4455556,11.2866667 C13.3166667,11.5744444 14.2577778,11.73 15.2222222,11.73 C15.65,11.73 16,12.08 16,12.5077778 L16,15.2222222 C16,15.65 15.65,16 15.2222222,16 C7.91888889,16 2,10.0811111 2,2.77777778 C2,2.35 2.35,2 2.77777778,2 L5.5,2 C5.92777778,2 6.27777778,2.35 6.27777778,2.77777778 C6.27777778,3.75 6.43333333,4.68333333 6.72111111,5.55444444 C6.80666667,5.82666667 6.74444444,6.13 6.52666667,6.34777778 L4.81555556,8.05888889 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcPhone);
export default __webpack_public_path__ + "static/media/18_ic_phone.602fded8.svg";
export { ForwardRef as ReactComponent };